<template>
  <div class="customer-service">
    <second-menu-link-content>
      <template v-slot:header>
        <span>客服设置</span>
      </template>
      <template v-slot:content>
        <div class="customer-service-main">
          <div class="add-customer-service">
            <el-button class="btn-blue" @click="add">添加客服</el-button>
            <el-dialog title="添加客服" :visible.sync="dialogVisible" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="客服名称：" prop="name">
                  <el-input v-model="ruleForm.name" class="gray" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="客服类型：" prop="classifyType">
                  <el-select v-model="ruleForm.classifyType" class="gray" placeholder="请选择类型">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系方式：" prop="phone">
                  <el-input v-model="ruleForm.phone" class="gray" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
                  <el-button class="btn-blue" @click="submit('ruleForm')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
          <div class="table" ref="table">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="name" label="客服名称"></el-table-column>
              <el-table-column prop="phone" label="联系方式"></el-table-column>
              <el-table-column prop="classify" label="类型"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="change(scope.row,scope.$index )"
                  >修改</el-button>
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="remove(scope.row.id, scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog title="修改客服" :visible.sync="dialogVisible2" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm2"
                :rules="rules"
                ref="ruleForm2"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="客服名称：" prop="name">
                  <el-input v-model="ruleForm2.name" class="gray" placeholder="请输入客服名称"></el-input>
                </el-form-item>
                <el-form-item label="客服类型：" prop="classifyType">
                  <el-select v-model="ruleForm2.classifyType" class="gray" placeholder="请选择类型">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系方式：" prop="phone">
                  <el-input v-model="ruleForm2.phone" class="gray" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm2')">取消</el-button>
                  <el-button class="btn-blue" @click="save('ruleForm2')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBMall from "models/db/mall.js";
const dbMall = new DBMall();
export default {
  data() {
    return {
      tableData: [
        // {
        //   id: '45452145',
        //   name: '虞姬',
        //   phone: '13111111111',
        //   classify: '服务'
        // },
      ],
      ruleForm: {
        name: "",
        classifyType: "",
        phone: ""
      },
      ruleForm2: "",
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        classifyType: [
          { required: true, message: "请选择类型", trigger: "change" }
        ],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }]
      },
      options: [
        {
          value: 1,
          label: "QQ"
        },
        {
          value: 2,
          label: "旺旺"
        },
        {
          value: 3,
          label: "电话"
        }
      ],
      dialogVisible: false,
      dialogVisible2: false,
      index: ""
    };
  },
  components: {
    SecondMenuLinkContent
  },
  beforeMount() {
    this.getCusservice();
  },
  methods: {
    // 获取客服数据
    getCusservice() {
      dbMall.getDBCusservice().then(res => {
        if (res.success) {
          this.tableData = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.name = value.cusServiceName;
            obj.phone = value.cusServiceContent;
            obj.id = value.id;
            obj.classifyType = value.cusServiceType;
            let cusServiceType = value.cusServiceType;
            if (cusServiceType === 1) {
              obj.classify = "QQ";
            } else if (cusServiceType === 2) {
              obj.classify = "旺旺";
            } else if (cusServiceType === 3) {
              obj.classify = "电话";
            }
            this.tableData.push(obj);
          });
        }
      });
    },
    // 点击添加按钮
    add() {
      this.dialogVisible = true;
    },
    // 重置
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.dialogVisible2 = false;
    },
    // 保存添加
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let cusServiceName = this.ruleForm.name;
          let cusServiceType = this.ruleForm.classifyType;
          let cusServiceContent = this.ruleForm.phone;
          let data = {
            cusServiceName,
            cusServiceType,
            cusServiceContent
          };
          dbMall.postDBAddCusservice(data).then(res => {
            if (res.success) {
              this.dialogVisible = false;
              this.getCusservice();
              this.$refs[formName].resetFields();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除客服
    remove(id, index) {
      this.$confirm(`是否确认删除该客服`, "删除客服", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        dbMall.postDBDeleteCusservice(id).then(res => {
          if (res.success) {
            this.dialogVisible = false;
            this.tableData.splice(index, 1);
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 修改客服
    change(row, index) {
      this.dialogVisible2 = true;
      console.log(row);
      this.ruleForm2 = JSON.parse(JSON.stringify(row));
    },
    // 保存修改
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let id = this.ruleForm2.id;
          let cusServiceName = this.ruleForm2.name;
          let cusServiceType = this.ruleForm2.classifyType;
          let cusServiceContent = this.ruleForm2.phone;
          let data = {
            id,
            cusServiceName,
            cusServiceType,
            cusServiceContent
          };
          dbMall.postDBUpdateCusservice(data).then(res => {
            if (res.success) {
              this.getCusservice();
              this.$refs[formName].resetFields();
              this.dialogVisible2 = false;
              this.$message.success("修改成功");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-service {
  width: 100%;
  height: 100%;
  .customer-service-main {
    .add-customer-service {
      margin-bottom: 16px;
      .el-button {
        width: 128px;
      }
    }
  }
}
</style>
<style lang="scss">
.customer-service {
  .customer-service-main {
    .el-dialog {
      border-radius: 4px;
      .el-dialog__header {
        padding: 0 24px;
        line-height: 48px;
        color: #606266;
        font-family: "PingFangSC-Medium";
        letter-spacing: 1px;
        .el-dialog__title {
          font-size: 16px;
          color: #606266;
          font-weight: 500;
        }
        .el-dialog__headerbtn {
          top: 15px;
        }
      }
      .el-dialog__body {
        padding: 0px 16px 16px 16px;
        .border {
          border-bottom: 1px solid #f7f7f7;
          margin-bottom: 16px;
        }
        .el-form {
          .el-form-item:last-child {
            margin-bottom: 0px;
          }
          .el-form-item {
            margin-bottom: 16px;
            .el-form-item__label {
              line-height: 32px;
            }
            .el-form-item__content {
              line-height: 32px;
              .el-select {
                width: 100%;
              }
              .el-form-item__error {
                padding-top: 2px;
              }
              .el-button {
                width: 96px;
              }
              .el-button.btn-blue {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
